import firebase from 'firebase/app';


const firebaseConfig = {
    apiKey: "AIzaSyBwc_Cv4XKYdSLG1fVcphjCgm6aMDOtJm4",
    authDomain: "eazzi-cash.firebaseapp.com",
    databaseURL: "https://eazzi-cash.firebaseio.com",
    projectId: "eazzi-cash",
    storageBucket: "",
    messagingSenderId: "726801789569",
    appId: "1:726801789569:web:931e263050a1cead07d380"
  };

// Initialize Firebase
firebase.initializeApp(firebaseConfig);